import { Helmet } from "react-helmet";

interface GlossaryTerm {
  term: string;
  definition: string;
}

interface GlossaryProps {
  terms: GlossaryTerm[];
  title?: string;
}

export const Glossary = ({ terms, title = "Begriffserklärungen" }: GlossaryProps) => {
  const schemaData = {
    "@context": "https://schema.org",
    "@type": "DefinedTermSet",
    "name": title,
    "hasDefinedTerm": terms.map(({ term, definition }) => ({
      "@type": "DefinedTerm",
      "name": term,
      "description": definition
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaData)}
        </script>
      </Helmet>
      <section className="my-12 p-6 bg-muted/30 rounded-lg">
        <h2 className="text-2xl font-bold mb-6">{title}</h2>
        <dl className="space-y-4">
          {terms.map(({ term, definition }, index) => (
            <div key={index} className="border-b border-border pb-4 last:border-0">
              <dt className="font-semibold text-foreground mb-1">{term}</dt>
              <dd className="text-muted-foreground">{definition}</dd>
            </div>
          ))}
        </dl>
      </section>
    </>
  );
};
